import { Icon } from '@iconify/react'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import hero from '../assets/images/hero-login.png'
import logo from '../assets/images/icon.png'
import { useAuth } from '../hooks/useAuth'
import {
   Button,
   FormContainer,
   FormWrap,
   HeroMock,
   Input,
   InputWrap,
   Label,
   Left,
   Logo,
   Page,
   PasswordToggle,
   Right,
   Subtitle,
   Title
} from '../styles/LoginStyle'


export default function SignIn(): React.JSX.Element {
   const navigate = useNavigate()
   const { login } = useAuth()
   const [show, setShow] = useState(false)
   const [loading, setLoading] = useState(false)
   const email = useRef<HTMLInputElement | null>(null)
   const password = useRef<HTMLInputElement | null>(null)

   const handleLogin = async (e?: React.FormEvent) => {
      e?.preventDefault()
      const emailValue = email.current?.value.trim()
      const passwordValue = password.current?.value

      if (!emailValue || !passwordValue) {
         toast.error('Please enter both email and password')
         return
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(emailValue)) {
         toast.error('Please enter a valid email address')
         return
      }

      setLoading(true)
      try {
         await login({ emailAddress: emailValue, password: passwordValue })
         toast.success('Login successful!')
         navigate('/overview', { replace: true })
      } catch (error) {
         toast.error(error instanceof Error ? error.message : 'Login failed. Please check your credentials.')
      } finally {
         setLoading(false)
      }
   }

   return (
      <Page>
         <Left>
            <Logo src={logo} alt="Ade Mart" />

            <FormWrap>
               <FormContainer>
                  <Title>Sign in to continue</Title>
                  <Subtitle>Login with your credentials to access users, track transactions, and manage crypto or gift cards securely</Subtitle>

                  <form onSubmit={handleLogin}>
                     <div className="mb-6">
                        <Label htmlFor="email">Email address</Label>
                        <Input ref={email} id="email" type="email" placeholder="babatunde@ademartapp.com" />
                     </div>

                     <div className="mb-2">
                        <Label htmlFor="password">Password</Label>
                        <InputWrap>
                           <Input ref={password} id="password" type={show ? 'text' : 'password'} placeholder="Enter your password" />

                           <PasswordToggle type="button" onClick={() => setShow(s => !s)}>
                              <Icon icon={show ? 'solar:eye-closed-linear' : 'solar:eye-linear'} width={18} />
                           </PasswordToggle>
                        </InputWrap>
                     </div>
                     <Button type="submit" disabled={loading}>
                        {loading ? (
                           <>
                              <Icon icon="svg-spinners:ring-resize" width={16} />
                              Signing in...
                           </>
                        ) : (
                           <>
                              Sign in <Icon icon="solar:arrow-right-linear" width={16} />
                           </>
                        )}
                     </Button>
                  </form>
               </FormContainer>
            </FormWrap>
         </Left>
         <Right>
            <HeroMock src={hero} alt="Dashboard preview" />
         </Right>
      </Page>
   )
}
